import script from "./MailHeaderOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./MailHeaderOptions.vue?vue&type=script&setup=true&lang=js"

import "./MailHeaderOptions.vue?vue&type=style&index=0&id=eccc8ac6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eccc8ac6"]])

export default __exports__